import AuthAlert from "@/components/tuw/auth/AuthAlert"
import WaitingScreen, { RESTART_PATH, WaitingColumn } from "@/components/tuw/openHouse/WaitingScreen"
import GuestShell from "@/components/tuw/viewingRoom/GuestShell"
import { Button } from "@/components/ui/button"
import { REGISTRATION as R } from "@/lib/openHouse/wording"
import { continueSignedIn, enrollmentFlow } from "@/lib/viewingRoom/enrollment"
import { VR } from "@/lib/viewingRoom/wording"

// The account box's waiting screen as its own page (GET /join/account, Viewing
// Room VR-9), where the email's link page returns: this browser's waiting
// enrollment, with the lines of the action it keeps. Without one here (none
// made, or deleted at its deadline), the approved line for no waiting account,
// the way to sign in and a fresh start.
//
// `waiting` is the server's Confirmation.waiting, or null; `action` and
// `penName` come from the kept intent.
export default function ViewingRoomWaiting({ waiting, action, penName }) {
  if (!waiting) {
    return (
      <WaitingColumn>
        <AuthAlert tone="bad">{VR.confirmation.noPendingAccount}</AuthAlert>
        <Button onClick={() => continueSignedIn()}>{R.existingButton}</Button>
        <Button asChild variant="outline">
          <a href={RESTART_PATH}>{VR.confirmation.accountExpired.startAgain}</a>
        </Button>
      </WaitingColumn>
    )
  }

  const flow = enrollmentFlow(action, penName ?? "")
  // An enrollment kept no action (or its freelancer is gone): no action line.
  if (!action || !penName) flow.lead = null
  return <WaitingScreen waiting={waiting} flow={flow} />
}

ViewingRoomWaiting.layout = (page) => <GuestShell>{page}</GuestShell>
